import React, { ReactNode } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';

export type WhatsAppShareProps = WithTrack & {
  children: ReactNode;
  url: string;
  className?: string;
  message: string;
  trackingData?: Record<string, any>;
};

export class WhatsAppShare extends React.PureComponent<WhatsAppShareProps> {
  trackClick = () => {
    const { track, trackingData } = this.props;
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'whatsapp',
      ...trackingData,
    });
  };

  render() {
    const { children, className, message, url } = this.props;
    const fullMessage = encodeURIComponent(`${message} ${url}`);

    return (
      <a
        data-qa="whatsapp-btn"
        href={`https://wa.me/?text=${fullMessage}`}
        className={`jg-btn jg-btn--whatsapp ${className}`}
        onClick={this.trackClick}
      >
        {children}
      </a>
    );
  }
}

export default withTrack(WhatsAppShare);
